import { Translator } from '@/types/translator.type';

export const CIRCUIT_DUPLICATION_FIELDS = (t: Translator) => [
  {
    label: t('circuits.duplicationFields.generalInfo'),
    value: 'name;countries;currencies;marginRate;remarks',
  },
  {
    label: t('circuits.duplicationFields.duration'),
    value: 'durationDays;durationNights',
  },
  {
    label: t('circuits.duplicationFields.participants'),
    value: 'nbParticipants',
  },
  {
    label: t('circuits.duplicationFields.descriptions'),
    value:
      'mainImage;images;summary;importantPoints;priceIncludes;priceExcludes;circuitAdditionalParagraphs',
  },
  {
    label: t('circuits.duplicationFields.modificationConditions'),
    value: 'modificationConditions;cancellationConditions',
  },
];
